import { apiClient } from "@/services/api-client";
import { createJwtToken } from "@/services/jsonwebtoken";

export const loginApi = async (data) => {
  const requestToken = createJwtToken();

  return await apiClient({
    url: `/v2/login`,
    method: "POST",
    data,
    headers: {
      "X-Requested-Token": requestToken,
    },
  });
};

export const otpVerifyApi = (data) => {
  return apiClient({
    url: `/v2/otp-verify`,
    method: "POST",
    data,
  });
};

export const otpResendApi = (data) => {
  const requestToken = createJwtToken();

  return apiClient({
    url: `/v1/otp-resend`,
    method: "POST",
    data,
    headers: {
      "X-Requested-Token": requestToken,
    },
  });
};

export const registrationApi = (data) => {
  const requestToken = createJwtToken();

  return apiClient({
    url: `/v2/registration`,
    method: "POST",
    data,
    headers: {
      "X-Requested-Token": requestToken,
    },
  });
};
